var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCells(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92292 4.64679C10.141 5.02248 10.25 5.21032 10.25 5.41659C10.25 5.62285 10.141 5.81069 9.92292 6.18639L8.8817 7.98012C8.66363 8.35583 8.55459 8.54367 8.375 8.64675C8.19541 8.74992 7.97733 8.74992 7.54119 8.74992H5.45881C5.02267 8.74992 4.80459 8.74992 4.625 8.64675C4.44541 8.54367 4.33637 8.35583 4.1183 7.98012L3.07711 6.18639C2.85903 5.81069 2.75 5.62285 2.75 5.41659C2.75 5.21032 2.85903 5.02248 3.07711 4.64679L4.1183 2.85305C4.33637 2.47736 4.44541 2.28952 4.625 2.18639C4.80459 2.08325 5.02267 2.08325 5.45881 2.08325H7.54119C7.97733 2.08325 8.19541 2.08325 8.375 2.18639C8.55459 2.28952 8.66363 2.47736 8.8817 2.85305L9.92292 4.64679Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2549 9.64675C18.473 10.0225 18.582 10.2103 18.582 10.4166C18.582 10.6228 18.473 10.8107 18.2549 11.1864L17.2137 12.9801C16.9957 13.3558 16.8866 13.5437 16.707 13.6468C16.5274 13.7499 16.3094 13.7499 15.8732 13.7499H13.7909C13.3547 13.7499 13.1366 13.7499 12.957 13.6468C12.7774 13.5437 12.6684 13.3558 12.4504 12.9801L11.4091 11.1864C11.191 10.8107 11.082 10.6228 11.082 10.4166C11.082 10.2103 11.191 10.0225 11.4091 9.64675L12.4504 7.85305C12.6684 7.47736 12.7774 7.28952 12.957 7.18639C13.1366 7.08325 13.3547 7.08325 13.7909 7.08325H15.8732C16.3094 7.08325 16.5274 7.08325 16.707 7.18639C16.8866 7.28952 16.9957 7.47736 17.2137 7.85305L18.2549 9.64675Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92292 13.8135C10.141 14.1893 10.25 14.3771 10.25 14.5833C10.25 14.7896 10.141 14.9774 9.92292 15.3532L8.8817 17.1468C8.66363 17.5226 8.55459 17.7104 8.375 17.8135C8.19541 17.9167 7.97733 17.9167 7.54119 17.9167H5.45881C5.02267 17.9167 4.80459 17.9167 4.625 17.8135C4.44541 17.7104 4.33637 17.5226 4.1183 17.1468L3.07711 15.3532C2.85903 14.9774 2.75 14.7896 2.75 14.5833C2.75 14.3771 2.85903 14.1893 3.07711 13.8135L4.1183 12.0198C4.33637 11.6441 4.44541 11.4563 4.625 11.3532C4.80459 11.25 5.02267 11.25 5.45881 11.25H7.54119C7.97733 11.25 8.19541 11.25 8.375 11.3532C8.55459 11.4563 8.66363 11.6441 8.8817 12.0198L9.92292 13.8135Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCells);
export default __webpack_public_path__ + "static/media/cells.60b2c20e6b0afe545722c8e2c3f0e74c.svg";
export { ForwardRef as ReactComponent };